module.exports = "npm i react-native-svg --save\nreact-native link react-native-svg"